import { usePathname } from '../../../routes/hooks';
import { ListItemButton, Stack } from '@mui/material';
import { RouterLink } from '../../../routes/components';
import navConfig from '../config-navigation';
import { alpha } from '@mui/material/styles';
import { UserInfoModel } from '../../../pages/user/models/user.model';

export interface NavItemMobileProps {
  user: UserInfoModel | null;
}
const MenuItemMobile = (_props: NavItemMobileProps) => {
  return (
    <Stack component="nav" spacing={0.5} sx={{ mt: 2 }}>
      {navConfig.map((item: any, index: number) => (
        <NavItemMobile key={index} item={item} />
      ))}
    </Stack>
  );
};

const NavItemMobile = ({ item }: any) => {
  const pathname = usePathname();
  const active = item.path === pathname;

  if (item?.child) {
    return item?.child?.map((itm: any, indx: number) => (
      <NavItemMobile key={indx} item={itm} isChild={true} />
    ));
  } else {
    return (
      <ListItemButton
        component={RouterLink}
        href={item?.path}
        sx={{
          padding: '0px',
          minHeight: 44,
          borderRadius: 5,
          alignItems: 'center',
          justifyContent: 'center',
          color: '#5A5A5A',
          ...(active && {
            color: '#EEEFF3',
            fontWeight: 'fontWeightSemiBold',
            bgcolor: (theme) => alpha(theme.palette.primary.main, 1),
            '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16) },
          }),
        }}
      >
        {item.icon != '' && item.icon}
      </ListItemButton>
    );
  }
};

export default MenuItemMobile;
